export default __webpack_public_path__ + "static/media/mc_front_closed.5cb5c0cd.svg";